import { I18nextProvider } from 'react-i18next';
import { ModalProvider } from '@taxdown/piccolo-web';
import { hideLauncher } from 'Services/chat';
import i18n from 'Services/i18n';
import { KamiProvider } from 'Context/KamiContext';
import useEvents from 'Hooks/useEvents';
import RouteHandler from 'Containers/RouteHandler';
import Modal from 'Components/Modal';
import Loader from 'Components/Loader';
import { Toast } from 'Components/Toast';
import ErrorBoundary from 'Components/ErrorBoundary';
import RouteListener from 'Components/RouteListener';
import { LazyAnalyticsHead } from 'Lazy/index';
import Theme from 'Styles/Theme';
import 'Config/sentry';

import { AppContainer } from './styles';

const App = () => {
  hideLauncher();
  useEvents();

  return (
    <I18nextProvider i18n={i18n}>
      <Theme>
        <ErrorBoundary>
          <KamiProvider>
            <LazyAnalyticsHead />
            <ModalProvider>
              <AppContainer>
                <RouteListener />
                <Modal />
                <Loader />
                <Toast />
                <RouteHandler />
              </AppContainer>
            </ModalProvider>
          </KamiProvider>
        </ErrorBoundary>
      </Theme>
    </I18nextProvider>
  );
};

export default App;
